import PropTypes from 'prop-types';

export const ActionIndicatorType = PropTypes.shape({
  show: PropTypes.bool,
  tooltip: PropTypes.string,
});
